export default "__VITE_ASSET__10c948d1__"